export const SHOP_BY_CATEGORY_PATH = '/category';
export const SEARCH_RESULTS_PATH = '/sr-artworks';
export const SEO_LP_PATH = '/posters';
export const ACCESSORIES_PATH = '/accessories';
export const ARTWORKS_PER_PAGE = 64;
export const SEARCH_MAGNET_PHRASES = [
    '3d magnet',
    'accessories',
    'accessory',
    'add-ons',
    'attachments',
    'desk stand',
    'displate accessories',
    'displate accessory',
    'hanging',
    'magnet',
    'mounting',
    'pop out',
    'spare magnet',
    'standing',
    'sticker magnet',
    'toolless',
    'wall mounting',
    'wallmount',
];
export const MIN_CHARACTERS = 2;
//# sourceMappingURL=search.js.map